import { useState, useEffect } from 'react';
import { ScrapbookManager } from '@/components/scrapbook/ScrapbookManager';

export default function ScrapbookModule() {
  const [myWidth, setMyWidth] = useState<number>(1440);
  const [isClient, setIsClient] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // Ensure we're on the client side before accessing window
  useEffect(() => {
    setIsClient(true);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    const handleResize = (e: Event) => {
      const target = e.target as Window;
      const width = target.innerWidth;
      setMyWidth(width);
    };

    const initialWidth = typeof window !== 'undefined' ? window.innerWidth : 1440;
    setMyWidth(initialWidth);

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (!isClient || isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white">
        <div className="text-center">
          <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-b-2 border-gray-900"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="container mx-auto p-0">
        <div className="flex">
          {myWidth < 961 ? (
            <div className="w-full">
              <div className="mx-3 p-3">
                <h3 className="pt-6 pb-4 text-center text-xl font-bold">
                  Sorry, our Scrapbook tool is designed for desktop screens only
                </h3>
              </div>
            </div>
          ) : (
            <div className="w-full">
              <ScrapbookManager scrapbookPageEnabled={true} />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
